import axios from 'axios'
import store from '../store'
import { TEST_URl } from '@/utils/constants.js'
const defaultBaseUrl = `${process.env.VUE_APP_BASE_URL}/account`
const testUrl = localStorage.getItem(TEST_URl)
const testBaseUrl = `${testUrl}/account`
const baseUrl = testUrl ? testBaseUrl : defaultBaseUrl

export async function getBaseUrlService (payload) {
  const res = await axios.get(`${payload}`)
  return res
}
export async function registerService (userData) {
  const res = await axios.post(`${baseUrl}/signup`, {
    ...userData
  })
  return res
}
export async function googleRegisterService (userData) {
  const res = await axios.post(`${baseUrl}/signup/google`, {
    ...userData
  })
  return res
}
export async function loginService (userData) {
  const res = await axios.post(`${baseUrl}/login`, {
    ...userData
  })
  return res
}
export async function googleLoginService (userData) {
  const res = await axios.post(`${baseUrl}/login/google`, {
    ...userData
  })
  return res
}
export async function verifyEmailService (userData) {
  const res = await axios.post(`${baseUrl}/verify-email`, {
    ...userData
  })
  return res
}
export async function forgotPasswordService (userData) {
  return await axios.post(`${baseUrl}/forgot-password/${userData}`)
}
export async function resetPasswordService (userData) {
  const res = await axios.post(`${baseUrl}/reset-password`, {
    ...userData
  })
  return res
}
export async function changePasswordService (userData) {
  const res = await axios.post(`${baseUrl}/change-password`, { ...userData })
  return res
}
export async function resendVerificationEmailService (userData) {
  return await axios.post(`${baseUrl}/resend-email-verification/${userData}`)
}
export async function initiate2faService (userData) {
  return await axios.post(`${baseUrl}/2fa/initiate/${userData}`)
}
export async function complete2faService (userData) {
  const res = await axios.post(`${baseUrl}/2fa/complete`, {
    ...userData
  })
  return res
}
export async function verify2faService (userData) {
  const res = await axios.post(`${baseUrl}/2fa/verify`, {
    ...userData
  })
  return res
}
export async function businessConfigurationService () {
  const res = await axios.get(`${baseUrl}/configuration`)
  return res
}
export async function localTransferDetailsService () {
  const res = await axios.get(`${baseUrl}/local-transfer-details`)
  return res
}
export async function transferDetailsService () {
  const res = await axios.get(`${baseUrl}/transfer-details`)
  return res
}
export async function completePtAccountService (payload) {
  const res = await axios.post(`${baseUrl}/pt/widget-completed`, { ...payload })
  return res
}
export async function refreshTokenService (keepMeLoggedIn) {
  // set extendToken as false if keep me logged in is false
  const extendTokenParams = `?extendToken=${keepMeLoggedIn}`
  const refreshToken = store.state.auth.refreshToken
  const res = await axios.post(
    `${baseUrl}/token/refresh${extendTokenParams}`,
    null,
    {
      headers: {
        Authorization: `Bearer ${refreshToken}`,
        tenant: localStorage.getItem('tenant')
      }
    }
  )
  return res
}
export async function inviteNewUserService (userData) {
  const res = await axios.post(`${baseUrl}/invite-user`, { ...userData })
  return res
}
export async function updateUserRoleService (userData) {
  const res = await axios.post(`${baseUrl}/user/update`, { ...userData })
  return res
}
export async function verifyUserInviteService (userData) {
  const res = await axios.post(`${baseUrl}/verify-user-invite`, {
    ...userData
  })
  return res
}
export async function getAllInvitedUsersService () {
  const res = await axios.get(`${baseUrl}/users`)
  return res
}

export async function deactivateUserService (userData) {
  const res = await axios.post(`${baseUrl}/user/deactivate/${userData}`, {})
  return res
}
export async function deleteUserService (userData) {
  const res = await axios.delete(`${baseUrl}/user/${userData}`, {})
  return res
}
export async function activateUserService (userData) {
  const res = await axios.post(`${baseUrl}/user/activate/${userData}`, {})
  return res
}
export async function cancelUserInviteService (userData) {
  const res = await axios.post(`${baseUrl}/cancel-user-invite/${userData}`, {})

  return res
}
export async function resendUserInviteService (userData) {
  const res = await axios.post(`${baseUrl}/resend-user-invite/${userData}`, {})

  return res
}
export async function adminBusinessAccessService (payload) {
  const res = await axios.post(
    `${baseUrl}/admin-access`,
    { ...payload },
    {
      headers: {
        tenant: localStorage.getItem('tenant')
      }
    }
  )
  return res
}
export async function verifyAdminBusinessAccessService (payload) {
  const res = await axios.post(`${baseUrl}/admin-access/verify`, { ...payload })
  return res
}
export async function getUserService (userId) {
  const res = await axios.get(`${baseUrl}/user/${userId}`)
  return res
}
export async function resendVerificationWithEmailService (userEmail) {
  return await axios.post(
    `${baseUrl}/resend-email-verification/email/${userEmail}`
  )
}
